"use strict";
export default function(location, history, onDone = null) {
  const comingFromFlowModePage = location.pathname == "/flow";
  const queryOnDone = location.query.onDone;
  if (comingFromFlowModePage || !queryOnDone || Array.isArray(queryOnDone) || queryOnDone.startsWith("/app/")) {
    navigateToDashboard(location, history, onDone);
  } else {
    history.pushState(null, queryOnDone, {});
  }
}
function navigateToDashboard(location, history, onDone) {
  let url = onDone || location.query.onDone || "/dashboard";
  let query = {};
  if (Array.isArray(url)) {
    url = url.pop();
  }
  const isPineDashboard = location.query.filters;
  const isElmDashboard = url.startsWith("/app/");
  if (isPineDashboard && !isElmDashboard) {
    query = { filters: location.query.filters };
  } else if (isElmDashboard) {
    url = url.replace(/^\/app\//, "/");
  }
  history.pushState(null, url, query);
}
